import { SearchOutlined } from '@ant-design/icons';
import { Input, Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import React from 'react';
import { TableSearchPanel } from 'ui/TableSearchPanel';

function OKEDTable({
  items,
  current,
  pageSize,
  loading,
  onRowClick,
  total,
  onChange,
}) {
  const columns = [
    {
      width: 100,
      title: 'Код',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Наименование',
      dataIndex: 'activity',
      key: 'activity',
      filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
        return (
          <TableSearchPanel>
            <Input
              autoFocus
              placeholder="Поиск по наименованию"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => confirm()}
            />
          </TableSearchPanel>
        );
      },
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        return record?.activity.toLowerCase().includes(value.toLowerCase());
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y }}
      pagination={{
        current,
        pageSize,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        total,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { OKEDTable };
